/* KraftStories reviews widget.
 *
 * The aggregate and the first page are already in the HTML, rendered by Liquid
 * from the reviews.* metafields — this only takes over when someone paginates,
 * filters, sorts or opens a photo. Loaded on intersection, so a page where the
 * reviews never scroll into view runs none of it.
 *
 * The lightbox is delegated from any [data-ksr-lightbox] container, so the
 * photo wall and the homepage rail get it without mounting a full widget. */
(function () {
  "use strict";

  var API = (document.currentScript && document.currentScript.dataset.api) ||
            "https://reviews.kraftstories.com";
  var PAGE = 10;

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function stars(rating) {
    var span = el("span", "ksr-stars");
    span.setAttribute("aria-hidden", "true");
    for (var i = 1; i <= 5; i++) {
      var star = el("i", null, "★");
      if (i > rating) star.setAttribute("data-off", "");
      span.appendChild(star);
    }
    return span;
  }

  function thumb(url, width) {
    // Widths and quality must match next.config.ts — anything else is refused
    // by the image optimiser with INVALID_IMAGE_OPTIMIZE_REQUEST.
    return API + "/_next/image?url=" + encodeURIComponent(url) + "&w=" + width + "&q=72";
  }

  /* ---------------- review modals ----------------
   * Six treatments, one shell. The shell owns the scrim, the escape key, the
   * scroll lock and returning focus, so the variants only decide their own
   * contents and cannot drift apart in behaviour.
   *
   *   split | story | sheet | gallery   one review
   *   all | browse                      many
   *
   * Style comes from data-ksr-modal on the nearest container, so a section can
   * choose without touching this file. */
  var MODAL_SINGLE = { split: 1, story: 1, sheet: 1, gallery: 1 };

  function esc(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function starsHtml(rating) {
    var out = "";
    for (var i = 1; i <= 5; i++) out += "<i" + (i > rating ? " data-off" : "") + ">\u2605</i>";
    return '<span class="st" aria-hidden="true">' + out + "</span>";
  }
  function metaHtml(r, withFoot) {
    return (r.product ? '<span class="kpm__tag">' + esc(r.product) + "</span>" : "") +
      '<div class="kpm__meta" style="margin-top:8px">' + starsHtml(r.rating) +
      '<span class="kpm__who">' + esc(r.author || "Verified buyer") + "</span>" +
      (r.date ? '<span class="kpm__date">' + esc(r.date) + "</span>" : "") + "</div>" +
      (r.body ? '<p class="kpm__body">' + esc(r.body) + "</p>" : "") +
      (withFoot ? '<div class="kpm__foot"><span>From a verified purchase</span></div>' : "");
  }

  var openModal = null;

  function closeModal() {
    if (!openModal) return;
    document.removeEventListener("keydown", openModal.onKey);
    document.body.style.overflow = openModal.prevOverflow;
    openModal.el.remove();
    if (openModal.lastFocus && openModal.lastFocus.focus) openModal.lastFocus.focus();
    openModal = null;
  }

  function mountModal(kind, render) {
    closeModal();
    var el = el2("div", "kp kpm kpm--" + kind);
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    var box = el2("div", "kpm__box");
    box.innerHTML = '<button class="kpm__x" aria-label="Close">\u2715</button>';
    el.appendChild(box);

    function onKey(e) { if (e.key === "Escape") closeModal(); }
    el.addEventListener("click", function (e) {
      if (e.target === el || e.target.closest(".kpm__x")) closeModal();
    });
    document.addEventListener("keydown", onKey);

    openModal = { el: el, onKey: onKey, prevOverflow: document.body.style.overflow,
                  lastFocus: document.activeElement };
    document.body.style.overflow = "hidden";
    document.body.appendChild(el);
    render(box, el);
    el.tabIndex = -1; el.focus();
    return box;
  }

  function el2(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }

  /* --- one review --- */
  function openSingle(kind, r) {
    var photos = (r.media && r.media.length ? r.media : [r.url]).filter(Boolean);
    var i = 0;
    mountModal(kind, function (box) {
      function draw() {
        var inner = "";
        if (kind === "story") {
          var segs = "";
          for (var n = 0; n < photos.length; n++) segs += "<i" + (n <= i ? " data-on" : "") + "></i>";
          inner =
            '<div class="kpm__img"><div class="kpm__segs">' + segs + "</div>" +
            '<img src="' + thumb(photos[i], 640) + '" alt="">' +
            (i > 0 ? '<button class="kpm__nav kpm__nav--prev" data-step="-1" aria-label="Previous">\u2039</button>' : "") +
            (i < photos.length - 1 ? '<button class="kpm__nav kpm__nav--next" data-step="1" aria-label="Next">\u203A</button>' : "") +
            '<div class="kpm__over">' + metaHtml(r, false) + "</div></div>";
        } else if (kind === "gallery") {
          var strip = "";
          for (var g = 0; g < photos.length; g++) {
            strip += '<button data-go="' + g + '"' + (g === i ? " data-on" : "") +
                     ' aria-label="Photo ' + (g + 1) + '"><img src="' + thumb(photos[g], 128) + '" alt=""></button>';
          }
          inner = '<div class="kpm__stage"><img src="' + thumb(photos[i], 1080) + '" alt=""></div>' +
                  (photos.length > 1 ? '<div class="kpm__strip">' + strip + "</div>" : "") +
                  '<div class="kpm__side"><span class="kpm__count">' + (i + 1) + " of " + photos.length +
                  " photo" + (photos.length === 1 ? "" : "s") + " from this review</span>" +
                  '<div style="height:10px"></div>' + metaHtml(r, true) + "</div>";
        } else if (kind === "sheet") {
          inner = '<div class="kpm__grab"></div><div class="kpm__img"><img src="' + thumb(photos[0], 640) +
                  '" alt=""></div><div class="kpm__side">' + metaHtml(r, true) + "</div>";
        } else {
          inner = '<div class="kpm__img"><img src="' + thumb(photos[0], 828) + '" alt=""></div>' +
                  '<div class="kpm__side">' + metaHtml(r, true) + "</div>";
        }
        box.insertAdjacentHTML("beforeend", inner);
      }
      draw();
      box.addEventListener("click", function (e) {
        var step = e.target.closest("[data-step]");
        var go = e.target.closest("[data-go]");
        if (!step && !go) return;
        i = go ? Number(go.dataset.go) : Math.min(photos.length - 1, Math.max(0, i + Number(step.dataset.step)));
        var keep = box.querySelector(".kpm__x");
        box.innerHTML = "";
        box.appendChild(keep);
        draw();
      });
    });
  }

  /* --- many reviews --- */
  function openList(kind, source) {
    mountModal(kind, function (box) {
      box.insertAdjacentHTML("beforeend", '<div class="kpm__list"><p class="kpm__empty">Loading reviews\u2026</p></div>');
      fetch(source.url)
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (data) {
          var keep = box.querySelector(".kpm__x");
          box.innerHTML = ""; box.appendChild(keep);
          if (kind === "browse") drawBrowse(box, data, source);
          else drawAll(box, data, source);
        })
        .catch(function () {
          var list = box.querySelector(".kpm__list");
          if (list) list.innerHTML = '<p class="kpm__empty">Couldn\u2019t load reviews just now.</p>';
        });
    });
  }

  function reviewItem(r) {
    var shots = "";
    (r.media || []).slice(0, 5).forEach(function (m) {
      shots += '<img src="' + thumb(m.url, 200) + '" alt="" data-ksr-photo="' + esc(m.url) + '">';
    });
    return '<article class="kpm__item">' + metaHtml({
      product: "", rating: r.rating, author: r.author, date: r.date, body: r.body,
    }, false) + (shots ? '<div class="kpm__shots">' + shots + "</div>" : "") + "</article>";
  }

  function drawAll(box, data, source) {
    var avg = source.average || "";
    var h = source.histogram || {};
    var chips = [["all", "All", ""]];
    [5, 4, 3, 2, 1].forEach(function (n) {
      // Only offer a rating that exists — an empty chip is a dead end.
      if (h[n]) chips.push([String(n), n + " star", h[n]]);
    });
    if (source.photoCount) chips.push(["photos", "With photos", source.photoCount]);

    var filters = chips.length > 1
      ? '<div class="kpm__filters">' + chips.map(function (c) {
          return '<button data-filter="' + c[0] + '"' + (c[0] === source.filter ? " data-on" : "") + ">" +
                 c[1] + (c[2] ? ' <span style="opacity:.6">' + c[2] + "</span>" : "") + "</button>";
        }).join("") + "</div>"
      : "";

    var head = '<div class="kpm__head"><div class="kpm__score">' +
      (avg ? '<b class="num">' + esc(avg) + "</b>" + starsHtml(Math.round(Number(avg))) : "") +
      '<span class="num" data-kpm-total>' + data.total + " review" + (data.total === 1 ? "" : "s") + "</span></div>" +
      filters + "</div>";

    box.insertAdjacentHTML("beforeend", head + '<div class="kpm__list"></div>');
    var list = box.querySelector(".kpm__list");

    /* The list pages as it scrolls. state.done latches once the server stops
     * having more to give, so a reader who keeps scrolling never re-requests
     * the tail. Changing a filter starts a new list, so it resets. */
    var state = { page: 1, filter: source.filter, total: data.total, loading: false, done: false };

    function urlFor(filter, page) {
      var url = new URL(source.baseUrl);
      if (filter === "photos") url.searchParams.set("photos", "1");
      else if (filter !== "all") url.searchParams.set("rating", filter);
      url.searchParams.set("page", String(page));
      return url.toString();
    }

    function shown() { return list.querySelectorAll(".kpm__item").length; }

    function foot(html) {
      var old = list.querySelector(".kpm__foot");
      if (old) old.remove();
      if (html) list.insertAdjacentHTML("beforeend", '<p class="kpm__foot">' + html + "</p>");
    }

    function settle(count) {
      // Fewer than a full page back, or everything accounted for: that is the end.
      if (!count || shown() >= state.total) {
        state.done = true;
        foot(state.page > 1 ? "That\u2019s all " + shown() + " review" + (shown() === 1 ? "" : "s") + "." : "");
      } else {
        foot("");
      }
    }

    function more() {
      if (state.loading || state.done) return;
      state.loading = true;
      foot("Loading more\u2026");
      var want = state.filter, next = state.page + 1;
      fetch(urlFor(want, next))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) {
          state.loading = false;
          // A filter change while this was in flight owns the list now.
          if (want !== state.filter) return;
          state.page = next;
          foot("");
          if (d.reviews.length) list.insertAdjacentHTML("beforeend", d.reviews.map(reviewItem).join(""));
          settle(d.reviews.length);
          fill();
        })
        .catch(function () {
          state.loading = false;
          foot("Couldn\u2019t load more just now.");
        });
    }

    function fill() {
      // A list too short to scroll never fires a scroll event, so top it up
      // until it can. Each pass consumes a page, and done/loading bound it.
      if (!state.done && !state.loading && list.scrollHeight <= list.clientHeight + 40) more();
    }

    function show(reviews) {
      list.innerHTML = reviews.length ? reviews.map(reviewItem).join("")
        : '<p class="kpm__empty">No reviews match that filter.</p>';
    }

    list.addEventListener("scroll", function () {
      if (list.scrollTop + list.clientHeight >= list.scrollHeight - 240) more();
    }, { passive: true });

    show(data.reviews);
    settle(data.reviews.length);
    fill();

    var row = box.querySelector(".kpm__filters");
    if (!row) return;
    row.addEventListener("click", function (e) {
      var chip = e.target.closest("[data-filter]");
      if (!chip || chip.dataset.filter === state.filter) return;
      var next = chip.dataset.filter;
      list.innerHTML = '<p class="kpm__empty">Loading\u2026</p>';
      row.querySelectorAll("[data-filter]").forEach(function (b) {
        if (b === chip) b.setAttribute("data-on", ""); else b.removeAttribute("data-on");
      });
      // A new filter is a new list: page 1 again, and nothing latched.
      state.filter = next; state.page = 1; state.done = false; state.loading = false;
      fetch(urlFor(next, 1))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (next !== state.filter) return;
          state.total = d.total;
          var count = box.querySelector("[data-kpm-total]");
          if (count) count.textContent = d.total + " review" + (d.total === 1 ? "" : "s");
          show(d.reviews);
          list.scrollTop = 0;
          settle(d.reviews.length);
          fill();
        })
        .catch(function () {
          list.innerHTML = '<p class="kpm__empty">Couldn\u2019t load those reviews.</p>';
        });
    });
  }

  function drawBrowse(box, data, source) {
    var withPhotos = data.reviews.filter(function (r) { return r.media && r.media.length; });
    if (!withPhotos.length) { drawAll(box, data, source); return; }
    var i = 0;
    function draw() {
      var grid = "";
      withPhotos.forEach(function (r, n) {
        grid += '<button data-go="' + n + '"' + (n === i ? " data-on" : "") +
                ' aria-label="Review by ' + esc(r.author) + '"><img src="' + thumb(r.media[0].url, 200) + '" alt=""></button>';
      });
      var r = withPhotos[i];
      box.insertAdjacentHTML("beforeend",
        '<div class="kpm__stage"><img src="' + thumb(r.media[0].url, 1080) + '" alt=""></div>' +
        '<div class="kpm__side"><div class="kpm__detail">' + metaHtml(r, true) + "</div>" +
        '<div class="kpm__pick"><h4>' + withPhotos.length + " review" + (withPhotos.length === 1 ? "" : "s") +
        ' with photos</h4><div class="kpm__grid">' + grid + "</div></div></div>");
    }
    draw();
    box.addEventListener("click", function (e) {
      var go = e.target.closest("[data-go]");
      if (!go) return;
      i = Number(go.dataset.go);
      var keep = box.querySelector(".kpm__x");
      box.innerHTML = ""; box.appendChild(keep);
      draw();
    });
  }

  /* --- triggers --- */
  function modalStyle(node, attr, fallback) {
    var host = node.closest("[" + attr + "]");
    return (host && host.getAttribute(attr)) || fallback;
  }

  document.addEventListener("click", function (event) {
    if (!event.target.closest) return;

    // "Read all reviews" / "Browse photos"
    var opener = event.target.closest("[data-ksr-open]");
    if (opener) {
      event.preventDefault();
      var root = document.querySelector("[data-ksr-root]");
      var q = new URLSearchParams();
      // The opener's own scope wins outright. A hero rating names one product,
      // but the review block further down the same page may be collection-wide,
      // and reading the block first would widen the hero's modal to the whole
      // collection. Only fall back to the block when the opener says nothing.
      var ids = root && root.dataset.productIds, pid = root && root.dataset.productId;
      if (opener.dataset.ksrProductIds) q.set("product_ids", opener.dataset.ksrProductIds);
      else if (opener.dataset.ksrProductId) q.set("product_id", opener.dataset.ksrProductId);
      else if (ids) q.set("product_ids", ids);
      else if (pid) q.set("product_id", pid);
      q.set("page", "1");
      if (opener.dataset.ksrOpen === "browse") q.set("photos", "1");
      var hist = {};
      try { hist = JSON.parse(opener.dataset.ksrHistogram || "{}"); } catch (e) { hist = {}; }
      openList(opener.dataset.ksrOpen, {
        url: API + "/api/v1/reviews?" + q.toString(),
        baseUrl: API + "/api/v1/reviews?" + q.toString(),
        average: opener.dataset.ksrAverage || "",
        histogram: hist,
        photoCount: Number(opener.dataset.ksrPhotos || 0),
        filter: "all",
      });
      return;
    }

    // A photo anywhere
    var host = event.target.closest("[data-ksr-lightbox]");
    if (!host) return;
    var hit = event.target.closest("[data-ksr-photo]");
    if (!hit) return;
    event.preventDefault();

    var card = hit.closest("figure, .ksr-card, .kpm__item");
    var payload = card && card.getAttribute("data-ksr-review");
    var r;
    if (payload) {
      try { r = JSON.parse(payload); } catch (e) { r = null; }
    }
    if (!r) {
      // Fall back to whatever the card already shows, so a photo without a
      // payload still opens with its own words rather than bare.
      var body = card && card.querySelector(".kp-wall__quote, .ksr-card__body");
      var who = card && card.querySelector(".kp-wall__by, .ksr-card__who");
      var tag = card && card.querySelector(".kp-wall__eyebrow");
      r = { url: hit.dataset.ksrPhoto, rating: 5,
            author: who ? who.textContent.trim() : "",
            product: tag ? tag.textContent.trim() : "",
            body: body ? body.textContent.trim() : "" };
    }
    r.url = r.url || hit.dataset.ksrPhoto;
    openSingle(modalStyle(hit, "data-ksr-modal", "story"), r);
  });

  /* ---------------- horizontal scrollers ----------------
   * The maker's wall pages by one card-width at a time. Delegated, so any
   * [data-ksr-scroller] with sibling [data-ksr-scroll] buttons works. */
  function cardStep(track) {
    var first = track.querySelector("figure, article");
    if (!first) return track.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(track).columnGap || "16") || 16;
    return first.getBoundingClientRect().width + gap;
  }

  function syncArrows(wall) {
    var track = wall.querySelector("[data-ksr-scroller]");
    if (!track) return;
    var prev = wall.querySelector('[data-ksr-scroll="-1"]');
    var next = wall.querySelector('[data-ksr-scroll="1"]');
    // 2px of slack: sub-pixel widths mean scrollLeft rarely hits the exact end.
    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest && event.target.closest("[data-ksr-scroll]");
    if (!btn) return;
    var wall = btn.parentElement;
    var track = wall && wall.querySelector("[data-ksr-scroller]");
    if (!track) return;
    track.scrollBy({ left: cardStep(track) * Number(btn.dataset.ksrScroll), behavior: "smooth" });
  });

  function initScrollers() {
    document.querySelectorAll("[data-ksr-scroller]").forEach(function (track) {
      var wall = track.parentElement;
      syncArrows(wall);
      track.addEventListener("scroll", function () { syncArrows(wall); }, { passive: true });
      if ("ResizeObserver" in window) new ResizeObserver(function () { syncArrows(wall); }).observe(track);
    });
  }

  /* ---------------- the product-page grid ---------------- */

  function Widget(root) {
    this.root = root;
    this.productId = root.dataset.productId;
    // Collection pages set data-product-ids and no data-product-id, so the
    // feed is mixed across every reviewed product in the collection.
    this.productIds = root.dataset.productIds || "";
    this.handle = root.dataset.handle;
    this.page = 1;
    this.rating = 0;
    this.photosOnly = false;
    this.sort = "recent";
    this.list = root.querySelector("[data-ksr-list]");
    this.controls = root.querySelector("[data-ksr-controls]");
    this.status = root.querySelector("[data-ksr-status]");
    this.bind();
  }

  Widget.prototype.bind = function () {
    var self = this;
    if (this.controls) {
      this.controls.addEventListener("click", function (event) {
        var button = event.target.closest("[data-ksr-filter]");
        if (!button) return;
        var value = button.dataset.ksrFilter;
        if (value === "photos") self.photosOnly = !self.photosOnly;
        else if (value === "all") { self.rating = 0; self.photosOnly = false; }
        else self.rating = self.rating === Number(value) ? 0 : Number(value);
        self.page = 1;
        self.reflect();
        self.load(true);
      });
      var select = this.controls.querySelector("[data-ksr-sort]");
      if (select) {
        select.addEventListener("change", function () {
          self.sort = select.value; self.page = 1; self.load(true);
        });
      }
    }
    this.root.addEventListener("click", function (event) {
      if (event.target.closest("[data-ksr-more]")) {
        // Continue from what is already on screen rather than from a counter.
        // Liquid renders the first page; if it ever renders a different number
        // than the API pages by, appending page+1 would skip the difference —
        // so an uneven count resyncs from page 1 instead of quietly losing rows.
        var rendered = self.list.children.length;
        if (rendered % PAGE !== 0) { self.page = 1; self.load(true); }
        else { self.page = rendered / PAGE + 1; self.load(false); }
      }
      var helpful = event.target.closest("[data-ksr-helpful]");
      if (helpful) self.vote(helpful);
    });
  };

  Widget.prototype.reflect = function () {
    if (!this.controls) return;
    var self = this;
    var buttons = this.controls.querySelectorAll("[data-ksr-filter]");
    Array.prototype.forEach.call(buttons, function (button) {
      var value = button.dataset.ksrFilter;
      var on = value === "photos" ? self.photosOnly
             : value === "all" ? (!self.rating && !self.photosOnly)
             : self.rating === Number(value);
      button.setAttribute("aria-pressed", on ? "true" : "false");
    });
  };

  Widget.prototype.url = function () {
    var q = new URLSearchParams();
    if (this.productIds) q.set("product_ids", this.productIds);
    else if (this.productId) q.set("product_id", this.productId);
    else q.set("handle", this.handle);
    q.set("page", String(this.page));
    q.set("sort", this.sort);
    if (this.rating) q.set("rating", String(this.rating));
    if (this.photosOnly) q.set("photos", "1");
    return API + "/api/v1/reviews?" + q.toString();
  };

  Widget.prototype.load = function (replace) {
    var self = this;
    if (this.status) this.status.textContent = "Loading…";
    fetch(this.url())
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        if (replace) self.list.innerHTML = "";
        data.reviews.forEach(function (review) { self.list.appendChild(self.card(review)); });
        if (!data.total && replace) {
          self.list.appendChild(el("p", "ksr-empty", "No reviews match that filter yet."));
        }
        // The list container carries the layout class (ksr-grid / ksr-list /
        // ksr-masonry) from Liquid; appended cards inherit it, so nothing here
        // needs to know which treatment is in use.
        if (self.status) {
          self.status.textContent = data.total +
            (data.total === 1 ? " review" : " reviews");
        }
        var more = self.root.querySelector("[data-ksr-more]");
        if (more) more.hidden = self.page * PAGE >= data.total;
      })
      .catch(function () {
        // The server-rendered reviews are still on screen; say what failed
        // rather than blanking a section that already had content in it.
        if (self.status) self.status.textContent = "Couldn't load more reviews just now.";
      });
  };

  Widget.prototype.card = function (review) {
    var card = el("article", "ksr-card");
    var head = el("div", "ksr-card__head");
    head.appendChild(stars(review.rating));
    head.appendChild(el("span", "ksr-card__who", review.author || "Verified buyer"));
    if (review.verified) head.appendChild(el("span", "ksr-card__ok", "Verified"));
    var date = el("time", "ksr-card__date", review.date);
    date.setAttribute("datetime", review.date);
    head.appendChild(date);
    card.appendChild(head);

    if (review.title) card.appendChild(el("h3", "ksr-card__title", review.title));
    if (review.body) card.appendChild(el("p", "ksr-card__body", review.body));

    if (review.media && review.media.length) {
      var strip = el("div", "ksr-card__photos");
      review.media.forEach(function (m) {
        var img = document.createElement("img");
        img.src = thumb(m.url, 200);
        img.loading = "lazy";
        img.width = 72; img.height = 72;
        img.alt = "";
        img.dataset.ksrPhoto = m.url;
        strip.appendChild(img);
      });
      card.appendChild(strip);
    }

    if (review.reply) {
      var reply = el("div", "ksr-card__reply");
      reply.appendChild(el("b", null, "KraftStories"));
      reply.appendChild(document.createTextNode(review.reply.body));
      card.appendChild(reply);
    }

    var helpful = el("button", "ksr-card__helpful",
      "Helpful" + (review.helpful ? " (" + review.helpful + ")" : ""));
    helpful.type = "button";
    helpful.dataset.ksrHelpful = review.id;
    card.appendChild(helpful);
    return card;
  };

  Widget.prototype.vote = function (button) {
    if (button.disabled) return;
    button.disabled = true;
    fetch(API + "/api/v1/vote", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ review_id: Number(button.dataset.ksrHelpful) }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { button.textContent = "Helpful (" + data.helpful + ")"; })
      .catch(function () { button.disabled = false; });
  };

  /* ---------------- product tabs ----------------
   * section-reviews.liquid shows one tab per reviewed product. Re-target the
   * widget instead of re-rendering the section: the API is already per-product,
   * so switching tabs is one fetch rather than a page's worth of Liquid. */
  document.addEventListener("click", function (event) {
    var tab = event.target.closest && event.target.closest("[data-ksr-product-id]");
    if (!tab) return;
    var group = tab.closest("[data-ksr-tabs]");
    if (!group) return;
    var root = group.querySelector("[data-ksr-root]");
    if (!root || !root.__ksr) return;

    var id = tab.getAttribute("data-ksr-product-id");
    if (!id || root.__ksr.productId === id) return;

    group.querySelectorAll("[data-ksr-product-id]").forEach(function (item) {
      var active = item === tab;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-selected", active ? "true" : "false");
    });

    root.__ksr.productId = id;
    root.__ksr.productIds = "";
    root.__ksr.handle = "";
    root.__ksr.page = 1;
    root.__ksr.rating = 0;
    root.__ksr.photosOnly = false;
    root.__ksr.reflect();
    root.__ksr.load(true);
  });

  function mount(root) {
    if (root.dataset.ksrReady) return;
    root.dataset.ksrReady = "1";
    // Kept on the element so the tab handler above can reach this instance.
    root.__ksr = new Widget(root);
  }

  function init() {
    initScrollers();
    // Mount every block outright. This used to wait on an IntersectionObserver,
    // but the first page of reviews is already server-rendered, so mounting only
    // attaches handlers to markup that exists -- there is nothing to defer, and
    // the observer's callback was never delivered on the storefront, which left
    // "Show more reviews" (and the rating filters) permanently inert.
    Array.prototype.forEach.call(document.querySelectorAll("[data-ksr-root]"), mount);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
